import { Constants } from "constants/Constants";

const ImageFromStrapiMedia = (media: any) => ({
  uri: media?.url
    ? media?.url?.startsWith("http")
      ? media?.url
      : `${Constants.ROOT_URL}${media?.url}`
    : "/images/fallback.jpg",
});

export default ImageFromStrapiMedia;
